import { render, staticRenderFns } from "./GiftRecipient.vue?vue&type=template&id=104e616e&scoped=true"
import script from "./GiftRecipient.vue?vue&type=script&lang=js"
export * from "./GiftRecipient.vue?vue&type=script&lang=js"
import style0 from "./GiftRecipient.vue?vue&type=style&index=0&id=104e616e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104e616e",
  null
  
)

export default component.exports